<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="createForm" @submit.prevent="create">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="First Name"
                          maxlength="64"
                          v-model="firstName"
                          :rules="rules.firstName" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="Last Name"
                          maxlength="64"
                          v-model="lastName"
                          :rules="rules.lastName" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field ref="email"
                          label="Email"
                          v-model="email"
                          validate-on-blur
                          :error-messages="serverError.email"
                          :rules="rules.email"
                          @focus="serverError.email = ''" />
          </v-col>
          <v-col cols="12" md="6">
            <PasswordGenerator ref="generator"
                               :special="true"
                               @generated="setPass" />
            <v-text-field label="Password"
                          v-model="password"
                          validate-on-blur
                          :rules="rules.password"
                          :append-icon="showPass ? 'visibility' : 'visibility_off'"
                          :type="showPass ? 'text' : 'password'"
                          @click:append="showPass = !showPass" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Confirm Password"
                          v-model="confirmPassword"
                          validate-on-blur
                          :rules="rules.confirmPassword"
                          :append-icon="showConfirmPass ? 'visibility' : 'visibility_off'"
                          :type="showConfirmPass ? 'text' : 'password'"
                          @click:append="showConfirmPass = !showConfirmPass" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>
              Roles and Permissions
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="ml-2" v-on="on">help</v-icon>
                </template>
                <ul>
                  <li>Author: Limited Read/Write Privileges</li>
                  <li>Editor: Read/Write/Edit/Publish. Limited Delete Privileges</li>
                  <li>Admin: Full Privileges. User management capabilities.</li>
                </ul>
              </v-tooltip>
            </h2>
          </v-col>
          <v-col cols="12">
            <v-radio-group label="Role" v-model="role">
              <v-radio label="Author"
                       :value="0" />
              <v-radio label="Editor"
                       :value="1" />
              <v-radio label="Admin"
                       :value="2" />
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn type="submit" color="primary" :loading="loading">
              Create
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import FormMixins from '@/components/Mixins/Forms';
import { rules } from '@/util/Helpers';

export default {
  name: 'CreateUserForm',
  mixins: [FormMixins],
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      role: 0,
      showPass: false,
      showConfirmPass: false,
      loading: false,
      serverError: {
        email: '',
      },
      rules: {
        firstName: [
          (v) => rules.required(v, 'First Name is required'),
        ],
        lastName: [
          (v) => rules.required(v, 'Last Name is required'),
        ],
        email: [
          (v) => rules.required(v, 'Please enter an Email'),
          (v) => rules.email(v, 'Please enter a valid Email'),
        ],
        password: [
          (v) => rules.required(v, 'Please enter a password'),
          (v) => rules.password(v),
        ],
        confirmPassword: [
          (v) => rules.required(v, 'Please confirm your password'),
          (v) => rules.match(v, this.password, 'Passwords must match'),
        ],
      },
    };
  },
  computed: {
    perms() {
      return [
        ['Author'],
        ['Author', 'Editor'],
        ['Author', 'Editor', 'Admin'],
      ][this.role];
    },
  },
  methods: {
    setPass(pass) {
      this.password = pass;
      this.confirmPassword = pass;
    },
    async create() {
      if (this.$refs.createForm.validate()) {
        this.loading = true;
        try {
          await this.$store.dispatch('post', {
            api: 'User',
            data: {
              FirstName: this.firstName,
              LastName: this.lastName,
              Email: this.email,
              Password: this.password,
              ConfirmPassword: this.confirmPassword,
              Roles: this.perms,
            },
          });
          this.$emit('snackbar', 'New User Created!');
        } catch (e) {
          const err = e.response.data;
          this.serverError.email = err.Message;
          this.$vuetify.goTo(this.$refs.email, { offset: 50 });
        }
        this.loading = false;
      } else {
        this.$refs.createForm.inputs.every(this.goToFirstError);
      }
    },
  },
};
</script>
